export const formatDate = (date: Date): string => {
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

export const getSunday = (date: Date): Date => {
  const day = date.getDay();
  const diff = day === 0 ? 0 : -day;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + diff);
};
